import {UiFieldBaseSchema} from "./UiField";
import {z} from "zod";

export const TextFieldSchema = UiFieldBaseSchema.extend({
    componentType: z.literal('TextField'),
});

export type TextField = z.infer<typeof TextFieldSchema>;
